<template>

  <v-row class="col-sm-12 col-md-12 col-12 pr-0 mr-0">
    <v-col col=12 class="px-0 mx-0">
    <v-form ref="addProtocoloLotesRecursadosForm">
    <v-data-table
      :headers="headers"
      :items="locallist"
      hide-default-footer                     
      :class="['lotesRecursadosTable', (envio_manual && !protocolo_pagamento) || (parametrizacao && (parametrizacao.RG_ENVIOEMAIL && parametrizacao.RG_ENVIOEMAIL_PROTOCOLO_MANUAL)) ? 'envio_manual': '', filterData.tipo_consulta=='guias'?'table-guias elevation-0' : 'elevation-0' ]"
      dense
      :items-per-page="pagination.limit"
    >
      <template class="center" v-slot:item.status="{ item }">
      <span>
        <v-tooltip center bottom>
          <template v-slot:activator="{ on, attrs }">
             <v-icon 
                class="icon_size"
                style="font-size 15px"
                v-bind="attrs"
                v-on="on"
                :color="getColor(item)"  
              >fa-circle</v-icon
            >
            
          </template>
          <span class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
          >{{getDescription(item)}}
          </span>
        </v-tooltip>
        <v-tooltip center bottom v-if="item.tipo_pagamento == 20">
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <v-icon v-bind="attrs" v-on="on" color="primary" class="px-1" style="font-size:13px !important">fa-exclamation</v-icon>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              Estorno
            </span>
          </v-tooltip>
        <v-btn v-if="(item.status_id == -1 || item.status_id == 4 || item.critica_ignorada)" color="primary" height="30px" small depressed icon @click="()=>{dadosLote=item;showErroDlg=true}">        
        <v-icon 
                class="icon_size"
                style="font-size: 15px"
                :color="item && item.critica_ignorada? '#118aca':'#D0021B'"  
              >far fa-eye
            </v-icon> 
        </v-btn>
        <!-- <v-tooltip center bottom v-if="item.erro_interno">
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
                class="icon_size"
                style="font-size 15px"
                v-bind="attrs"
                v-on="on"
                color="#A42B0A"  
              >fa-exclamation-triangle
            </v-icon>  
          </template>
          <span class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
          >{{item.erro_mensagem}}
          </span>
        </v-tooltip> -->
      </span>
         <!--<span v-html="getDescription(item).replace(' ', '<br>')"></span>-->
        
      </template>
      
          <template v-slot:item.protocolo_envio="{ item }">
              <b  v-if="(!envio_manual || tipo_protocolo=='pagamento' || item.valor_recursado <= 0) && (parametrizacao && ((parametrizacao.RG_ENVIOEMAIL && !parametrizacao.RG_ENVIOEMAIL_PROTOCOLO_MANUAL) || !parametrizacao.RG_ENVIOEMAIL))">{{item.protocolo_envio}}</b>
              <v-text-field 
                v-else
                dense
                type="text"
                v-model="item.protocolo_envio"
                flat
                :rules="[formRules.max20]"
                @input="exibirSalvar=true"
                class="mb-n5 input-no-border"
                >
              </v-text-field>
              <v-menu left offset-x :nudge-width="250" max-width="250px" v-if="(((!item.protocolo_envio || item.protocolo_envio == '') && item.protocolo_envio_guias && item.protocolo_envio_guias.length) || (item.protocolo_envio_itens && item.protocolo_envio_itens.length)) && getMostra(item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" small color="primary" icon>
                    <v-icon small color="primary">fa-eye</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <p v-if="item.protocolo_envio_guias && item.protocolo_envio_guias.length">
                    <b>Protocolo das guias:</b><br>
                      {{item.protocolo_envio_guias}} 
                    </p>
                    <p v-if="item.protocolo_envio_itens && item.protocolo_envio_itens.length">
                      <b>Protocolo dos itens:</b><br>
                      {{item.protocolo_envio_itens}}
                    </p>
                  </v-card-text>
                </v-card>
              </v-menu>
          </template>

          <template v-slot:item.numero_lote="{ item }">
              
              <b> {{ item.numero_lote != null && item.numero_lote != '' ? item.numero_lote : item.numero_lote_demonstrado }}</b>
          </template>

             <template v-slot:item.data_envio="{ item }" >
              <b v-if="(!envio_manual || tipo_protocolo=='pagamento' || item.valor_recursado <= 0) && (parametrizacao && ((parametrizacao.RG_ENVIOEMAIL && !parametrizacao.RG_ENVIOEMAIL_PROTOCOLO_MANUAL) || !parametrizacao.RG_ENVIOEMAIL))">{{item.dataEnvio = formatDate(item.data_envio)}}</b>
              <v-menu 
                  v-else
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  width="120"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="item.dataEnvio"
                    format="DD/MM/YYYY"
                    v-mask="'##/##/####'"
                    dense
                    flat
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @blur="item.data_envio = parseDate(item.dataEnvio)"
                    class="mb-n5 input-no-border"
                    :rules="[formRules.typeDateFormated]"
                  ></v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="item.data_envio"
                    no-title
                    @input="item.dataEnvio = formatDate(item.data_envio); exibirSalvar=true"
                    >
                  </v-date-picker>
                </v-menu>
            </template>
      <template v-slot:item.data_atualizacao="{ item }">
        {{ item.data_atualizacao | formatDate }}
      </template>
      <template v-slot:item.mensagens="{ item }">
        {{ item.status !== "Enviado" ? item.mensagens : null }}
      </template>

      <!-- <template v-slot:item.protocolo_recursado="{ item }">
        {{ item.protocolo_recursado != null && item.protocolo_recursado != '' ? item.protocolo_recursado : item.numero_protocolo_demonstrado }}
        
      </template> -->

      <template v-slot:item.vl_recursado="{ item }">
        <v-col v-if="item.valor_recursado != 0">
          <b><span style="color: rgb(50, 184, 139)">{{ item.valor_recursado | formatPrice }}</span></b>
        </v-col>
      </template>
      <template v-slot:item.vl_acatado="{ item }">
        <v-col v-if="item.valor_acatado != 0">
          <b><span style="color: red">{{ item.valor_acatado | formatPrice }}</span></b>          
        </v-col>
      </template>
      <template v-slot:item.docs="{ item }">
        <v-tooltip bottom open-delay="100" v-if="parametrizacao && (parametrizacao.RG_ANEXO_TISS || parametrizacao.RG_ENVIO_ANEXO) && !!item.qtde_anexos && item.qtde_anexos > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-badge 
                overlap
                class="mr-3" 
                style="font-weight: bold"
                color="accent"
                :content="item.qtde_anexos"
              >
            <v-icon
              class="mr-2"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewAnexos(item)"
              >fa-paperclip
            </v-icon>
            </v-badge>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >{{item.qtde_anexos == 1? '1 anexo' : item.qtde_anexos + ' anexos'}}</span
          >
        </v-tooltip>
        <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_recurso">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="download({ doc_id: item.doc_id_recurso })"
              >fa-file-code
            </v-icon>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Arquivo gerado</span
          >
        </v-tooltip>
        <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_protocolo">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="download({ doc_id: item.doc_id_protocolo })"
              >fa-file-contract
            </v-icon>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Protocolo de envio</span
          >
        </v-tooltip>
        <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_situacao">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="download({ doc_id: item.doc_id_situacao })"
              >fa-file-invoice
            </v-icon>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Situação de protocolo</span
          >
        </v-tooltip>
      </template>
      <template v-slot:item.icon="{ item }">
        <div style="white-space: nowrap; margin: 0; padding: 0;">
          <v-tooltip bottom open-delay="100">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                style="margin: 4px"
                color="primary"
                small
                v-bind="attrs"
                v-show="envio_digitacao_robo && exibirNivelGuia"
                v-on="on"
                @click="viewguias(item.id)"
                >far fa-eye
              </v-icon>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style="
                border: solid 1px #999;
                border-radius: 5px;
                background-color: #fff;
              "
              >Guias do Lote</span
            >
          </v-tooltip>
          <v-tooltip bottom open-delay="100" v-if="!!item.doc_id_capa">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              class="px-1 mx-0"
              small
              v-bind="attrs"
              v-on="on"
              @click="download({ doc_id: item.doc_id_capa })"
              >fa-file-image
            </v-icon>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >Capa de lote</span
          >
        </v-tooltip>
          <!-- 
          
            
          <v-tooltip bottom open-delay="100" v-if="item.status == -1 && statusPgto == 80">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                style="margin: 4px"
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
                @click="setFilter(null, null, item.identificador_prestador)"
                >fa-pencil-alt
              </v-icon>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style="
                border: solid 1px #999;
                border-radius: 5px;
                background-color: #fff;
              "
              >Editar lote com crítica</span
            >
          </v-tooltip> 
          <v-tooltip left offset-x :nudge-width="250" max-width="250px" v-if="item.status_id == -1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  icon
                  style="margin: 4px"
                  v-bind="attrs" 
                  v-on="on"
                  small 
                  color="error"
                  >fa-exclamation-triangle
                  </v-icon>
              </template>
              <v-card>
                <v-card-text>
                  {{item.mensagens}}
                </v-card-text>
              </v-card>
            </v-tooltip>       -->   
        </div>
        </template>
        <template v-slot:item.iconGuias="{ item }">
        <div style="white-space: nowrap; margin: 0; padding: 0;">
          <v-tooltip bottom open-delay="100" v-if="item.qtde_anexos > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-badge 
                overlap
                class="ml-1" 
                style="font-weight: bold"
                color="accent"
                :content="item.qtde_anexos"
              >
            <v-icon
              v-if="parametrizacao && (parametrizacao.RG_ANEXO_TISS || parametrizacao.RG_ENVIO_ANEXO) && !!item.qtde_anexos && item.qtde_anexos > 0"
              style="margin-right: 4px; margin-left: 0; padding-left:0"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewAnexos(item)"
              >fa-paperclip
            </v-icon>
            </v-badge>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >{{item.qtde_anexos == 1? '1 anexo' : item.qtde_anexos + ' anexos'}}</span
          >
        </v-tooltip>
          <v-tooltip bottom open-delay="100">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                style="margin: 4px"
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
                :disabled="item.flag_recurso_guia && item.qtd_itens_editados == 0"               
                @click="openAcompanhamentoEnvio(item)"
                >far fa-eye
              </v-icon>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style="
                border: solid 1px #999;
                border-radius: 5px;
                background-color: #fff;
              "
              >Itens da guia</span
            >
          </v-tooltip>
          <!-- BOTÂO PRA ENVIAR PRA EDIÇÃO -->
          <!-- <v-tooltip bottom open-delay="100" v-if="item.status_envio == -1 && statusPgto == 80">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                style="margin: 4px"
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
                @click="setFilter(tipo_consulta, item.numero_guia_prestador)"
                >fa-pencil-alt
              </v-icon>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style="
                border: solid 1px #999;
                border-radius: 5px;
                background-color: #fff;
              "
              >Editar guia com crítica</span
            >
          </v-tooltip> 
          <v-tooltip left offset-x :nudge-width="250" max-width="250px" v-if="item.status_envio == -1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  icon
                  style="margin: 4px"
                  v-bind="attrs" 
                  v-on="on"
                  small 
                  color="error"
                  >fa-exclamation-triangle
                  </v-icon>
              </template>
              <v-card>
                <v-card-text>
                  
                  {{item.mensagens}}
                </v-card-text>
              </v-card>
            </v-tooltip>-->
            </div>
        </template>
        
      

    </v-data-table>
    <template>
      <div style="margin-top: 30px" class="text-center py-0 col-md-12">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pagination.total_pages"
          @input="
            filterList( filterData, page )
          "
        ></v-pagination>
      </div>
      <v-card-actions class=" flex justify-center py-5">
        <v-btn color="primary" height="30px" small depressed v-show="exibirSalvar" @click="saveProtocolos()"
          > Salvar protocolos
        </v-btn>
      </v-card-actions>
    </template>
    <Modal 
      :close=" () => {  showModal = false; }"
      :dialog="showModal"
      :estadoList="estadoList"
      :filterData="filter"
      :getColor="getColor"
      :getDescription="getDescription"
      :getList="(formData, page)=>getList(formData, page, false)"
      :info="dadosGuia"
      :itensList="listaItens"
      :pagination="paginationItens"/>
      <ErroDlg 
      :close=" () => closeErros()"
      :dialog="showErroDlg"
      :info="dadosLote"
      :grupoEconomico="grupoEconomico"
      :updatePage="()=>filterList(filterData, page)"
      :finalizaEnvio = finalizaEnvio
      />
    </v-form>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
import Modal from "./AcompanhamentoModal.vue";
import { mapState } from "vuex";
import ErroDlg from '@/components/recebiveis/acompanhamento_de_envio/ErroDlg'
export default {
  components: {
    Modal,
    ErroDlg
  },
  data() {
    return {
      count: 0,
      dadosGuia: {},
      dadosLote:{},
      exibirSalvar: false,
      filter: {
        grupo_economico: this.grupoEconomico, 
        recurso_guia_id: null, 
        pagamento_id: null, 
        status_envio: null 
        },
      finalizaEnvio: false,
      headers:[],
      headersLotes: [
        { text: "Status", align: "center", class: "alt_header", value: "status", sortable: false, },
        //{ text: "Ident. na operadora", value: "identificador_prestador", align: "center", sortable: false, },
        { text: "Protocolo faturado", value: "protocolo_recursado", align: "center", sortable: false, },
        { text: "Protocolo demonstrado", value: "numero_protocolo_demonstrado", align: "center", sortable: false, },
        { text: "Nº do Lote", value: "numero_lote", align: "center", sortable: false },
        { text: "Nº de Guia do Recurso", value: "numero_guia_recurso", align: "center", sortable: false, },
        { text: "Protocolo envio", value: "protocolo_envio", align: "center", sortable: false },
        { text: "Data envio", value: "data_envio", align: "center", sortable: false },
        { text: "Retorno da Operadora", value: "mensagens", align: "center", sortable: false},
        { text: "Vl. Recursado (R$)", class: "nowrap_header", value: "vl_recursado", align: "center", sortable: false },
        { text: "Vl. Acatado (R$)", class: "nowrap_header", value: "vl_acatado", align: "center", sortable: false },
        { text: "Data atualização", value: "data_atualizacao", align: "center", sortable: false, },
        { text: "Documentos", value: "docs", align: "center", sortable: false },
      ],
      headersGuias: [
        { text: "Status", align: "center", width: "1px", value: "status", sortable: false, },
        //{ text: "Ident. na Operadora ", value: "identificador_prestador_captura", align: "center", sortable: false, },
        { text: "Nº guia prestador", value: "numero_guia_prestador", align: "center", sortable: false, },
        { text: "Protocolo recursado", value: "protocolo_recursado", align: "center", sortable: false, },
        //{ text: "Nº da guia na operadora", value: "numero_guia_operadora", align: "center", sortable: false, },
        { text: "Nº do lote", value: "numero_lote", align: "center", sortable: false },
        { text: "Protocolo envio", value: "protocolo_envio", align: "center", sortable: false },
        { text: "Data envio", value: "data_envio", align: "center", sortable: false },
        { text: "Retorno da Operadora", value: "mensagens", align: "center", sortable: false},
        { text: "Carteirinha", value: "carteira_beneficiario", align: "center", sortable: false, },
        { text: "Beneficiário", value: "nome_beneficiario", sortable: false },
        { text: "Vl. Recursado (R$)", value: "vl_recursado", align: "center", sortable: false },
        { text: "Vl. Acatado (R$)", value: "vl_acatado", align: "center", sortable: false },
        { text: "", value: "iconGuias", align: "center", sortable: false }
      ],
      listaItens: [],      
      locallist:[],
      envio_digitacao_robo: false,
      page: 1,
      pageCount: 0,
      paginationItens: {
        current_page: 1,
        offset: 1,
        total_pages: 0,
        limit: 5
      },
      statusPgto: null,
      showErroDlg: false,
      showModal: false,
    }
    },
    watch:{
      list(val){
        this.headers = this.filterData.tipo_consulta == "lotes" ? this.headersLotes : this.headersGuias
        this.page = this.pagination.current_page
        if (this.parametrizacao && this.parametrizacao.RG_FINALIZA_ENVIO)
          this.finalizaEnvio = this.parametrizacao.RG_FINALIZA_ENVIO
        this.locallist = val.map(item=> {
          item.dataEnvio = this.formatDate(item.data_envio)
          return item
        })
        this.$nextTick()
      },
      // parametrizacao() {
      // let temColunaAcao = this.headersLotes.findIndex(x=> x.value == "icon")
      // if(this.parametrizacao.RG_ENVIORECURSO_DIGITACAO){
      //   this.envio_digitacao_robo = true
      //   if(temColunaAcao == -1)
      //     this.headersLotes.push({ text: "", value: "icon", align: "center", sortable: false })
      // } else {
      //   this.envio_digitacao_robo = false
      //   this.filterData.tipo_consulta = 'lotes'
      //   if(temColunaAcao > -1)
      //    this.headersLotes.pop()
      // }
      //}
    },
    computed: {
      ...mapState({
        grupoEconomico: (state) => state.permissions.grupoEconomico,
        formRules: (state) => state.formRules,
        userData: (state) => state.userData
      }),
    },
    methods: {
      closeErros(){
        this.filterList(this.filterData, this.page);
        this.showErroDlg = false;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split("T")[0].split('-')
        return `${day}/${month}/${year}`
      },
      getMostra(item){
        let param =  this.filterData.tipo_consulta == 'lotes' ? 'status_id' : 'status_envio'

        return item[param] == 2 ? false : true

      },
      getColor(item){
        let param =  this.filterData.tipo_consulta == 'lotes' ? 'status_id' : 'status_envio'
        if(item[param] == 0){
          item[param] = 1
        }
        // let tag = param == 'status_envio' ? item.flag_recurso_guia : true
        // if((item.status_id == 1 || item.status_envio == 1) && item.valor_recursado == 0 && tag){
        //   let status = this.estadoList.find(el => el.descricao == 'Acatado')
        //   return status.color
        // } else {
          let status = this.estadoList.find(el => el.id == item[param])
          return status ? status.color : 'FFF'
        // }
        
      },
      getDescription(item){
        let param =  this.filterData.tipo_consulta == 'lotes' ? 'status_id' : 'status_envio'
        if(item[param] == 0){
          item[param] = 1
        }
        // let tag = param == 'status_envio' ? item.flag_recurso_guia : true

        // if((item.status_id == 1 || item.status_envio == 1) && item.valor_recursado == 0 && tag){
        //   let status = this.estadoList.find(el => el.descricao == 'Acatado')
        //   return status.descricao
        // } else {
          let status = this.estadoList.find(el => el.id == item[param])
          return status ? status.descricao : ''
        // }
        
      },
      parseDate (date) {
          if (!date) return null
          const [day, month, year] = date.split('/')
          return `${year}-${month}-${day}`
      },
      editar(){            
          this.setFilterAndUrl(this.list.recurso_guia_id)
      },
      download(docData) {
        let Payload = {
          grupo_economico: this.grupoEconomico,
          pagamento_id: this.dadosPagamento.id,
          ...docData,
        };
        this.$store.dispatch("documents/getDocument", Payload, {
          root: true,
        });
      },
      viewguias(lote) {
        let numero_lote = lote
        let tipo_consulta = 'guias'
        this.filterList({...this.filterData, numero_lote, tipo_consulta});
      },
      openAcompanhamentoEnvio(dadosGuia) {
          this.listaItens = []
          this.dadosGuia = dadosGuia
          let {id, pagamento_id} = dadosGuia
          this.getList( {status_envio: null, grupo_economico: this.grupoEconomico, recurso_guia_id:id, pagamento_id})
          this.showModal = true;
      },    
      getList(formData, page) {
          
          this.paginationItens.offset = page? page : 1
          this.filter = formData? formData : this.filter
          let payload = Object.assign({...this.filter, ...this.paginationItens})
          let obj = {query:[ {modulo: 'Recebiveis', acao: 'getitensrecursoglosa', payload}]}
          
          this.$store.dispatch("request/doRequest", obj, {root: true}).then(response => {
          if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
          }
          this.listaItens = response.dados
          this.paginationItens.current_page = response.current_page
          this.paginationItens.offset = response.current_page
          this.paginationItens.total_pages = response.total_pages
          })
      },
      saveProtocolos() {
        if(!this.$refs.addProtocoloLotesRecursadosForm.validate()){
            return
        }
        let {prestador_id, operadora_ans_id, data_pagamento, id} = this.dadosPagamento
        let protocolos = this.list.map(el => ({lote_id: el.id, protocolo_envio: el.protocolo_envio, data_envio: el.data_envio }))
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "AddProtocoloLotesRecursados",
              payload: {
                grupo_economico: this.grupoEconomico,
                protocolos,
                pagamento_id: id,
                prestador_id, 
                operadora_ans_id, 
                data_pagamento
              },
            },
          ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          let paramModal = {
              type: "success",
              title: "Sucesso",
              message: response.mensagem,
              callback: ()=> {this.exibirSalvar = false; this.filterList(this.filterData, this.page); },
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Não", show: false },
            };
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        });
      },
      viewAnexos(item){
        let recurso_lote_id = null
        let recurso_guia_id = null
        if(this.filterData.tipo_consulta == 'guias') {
          recurso_guia_id = item.id
          recurso_lote_id = item.recurso_lote_id
        } else {
          recurso_lote_id = item.id
        }
        let formData = {...this.filterAnexoData, recurso_guia_id, recurso_lote_id};
        this.filterAnexoList(formData, 1);
      }
    },
  props: {
    dadosPagamento: Object,
    envio_manual: Boolean,
    estadoList: Array,
    exibirNivelGuia: Boolean,
    filterData: Object,
    filterList: Function,
    filterAnexoData: Object,
    filterAnexoList: Function,
    list: Array,
    pagination: Object,
    parametrizacao: Object,
    protocolo_pagamento: Object,
    tipo_protocolo: String
  },
};
</script>
<style lang="scss">
    .alt_header {
      height: 45px !important;
    }
    .icon_size{
        font-size: 14px !important;
    }

.text-list {
  font-size: 13px;
  line-height: 1.15em;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable,
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable.table-guias {
  min-width: 100%;
  width: 100%;
  max-width: 100%;
}
.lotesRecursadosTable.envio_manual {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6), 
  .v-data-table__wrapper > table > tbody > tr td:nth-child(7) {
    background-color: rgba(207, 212, 3, .10) !important;
    min-width: 120px;
  }
}
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable  tr th,
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable  tr td {
    padding: 0 auto;
}
// .lotesRecursadosTable {
//   .v-data-table__wrapper > table > tbody > tr td:nth-child(7){
//     min-width: 12%;
//   }
// }
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(1),
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(2),
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(8),
.v-data-table.v-data-table--dense.theme--light.lotesRecursadosTable tr td:nth-child(9) {
    white-space: nowrap !important;
    padding: 0 6px;
}

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:last-child,
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:last-child {
  position: sticky !important;
  right: 0;
  /* Displayed on top of other rows when scrolling */
  z-index: 3;
  padding: 0 2px !important;
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:first-child,
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:first-child {
  position: sticky !important;
  left: 0;
  z-index: 3;
  
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(2),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(2)   {
  position: sticky !important;
  left: 47px;
  /* Displayed on top of other rows when scrolling 1*/
  z-index: 3;
  //min-width: 54px
}

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(3),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(3)   {
  position: sticky !important;
  left: 110px;
  /* Displayed on top of other rows when scrolling */
  /*trava a coluna */ 
  z-index: 3;
}

.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table {
  border-collapse: separate;
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:first-child,
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(2),

.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:nth-child(3),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > thead > tr th:last-child {
  background-color: #eff3f8;
  padding-left: 8px;
  padding-right: 8px;
}
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:first-child, 
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(2),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:nth-child(3),
.lotesRecursadosTable.table-guias .v-data-table__wrapper > table > tbody > tr td:last-child {
  background-color: rgb(255, 255, 255);
  padding-left: 8px;
  padding-right: 8px;
}



</style>

